import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'ShipToStoreContainer',
        path: () => path.join(__dirname, './ShipToStoreContainer'),
        resolve: () => require.resolveWeak('./ShipToStoreContainer'),
        load: () =>
            Promise.all([
                import(/* webpackChunkName: "ShipToStoreContainer" */ './ShipToStoreContainer'),
            ]).then((proms) => proms[0]),
    })
);
